import {
    FETCH_WELLNESS_DAILY_RESPIRATION_DATA,
    FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FETCHING,
    FETCH_WELLNESS_DAILY_RESPIRATION_DATA_SUCCESS,
    FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyRespirationData: {},
    isFetching: false,
    fetchFailed: false
};

const fetchDailyRespirationDataFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false
    };
};

const fetchDailyRespirationDataSuccess = (state, action) => {
    return {
        dailyRespirationData: {
            ...state.dailyRespirationData,
            [action.displayName]: {
                ...state.dailyRespirationData[action.displayName],
                [action.calendarDate]: action.dailyRespirationData
            }
        },
        isFetching: false,
        fetchFailed: false
    };
};

const fetchDailyRespirationDataFail = (state, action) => {
    return {
        dailyRespirationData: {
            ...state.dailyRespirationData,
            [action.displayName]: {
                ...state.dailyRespirationData[action.displayName],
                [action.calendarDate]: {}
            }
        },
        isFetching: false,
        fetchFailed: true
    };
};

const handlers = {
    [FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FETCHING]: fetchDailyRespirationDataFetching,
    [FETCH_WELLNESS_DAILY_RESPIRATION_DATA_SUCCESS]: fetchDailyRespirationDataSuccess,
    [FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FAIL]: fetchDailyRespirationDataFail
};

export default function dailyRespirationData(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchDailyRespirationData(displayName, calendarDate, nonSleepBufferMinutes, evictCache) {
    return {
        type: FETCH_WELLNESS_DAILY_RESPIRATION_DATA,
        displayName,
        calendarDate,
        nonSleepBufferMinutes
    };
}

export const getDailyRespirationData = (state, displayName, calendarDate) => {
    return state.dailyRespirationData.dailyRespirationData[displayName]
        ? state.dailyRespirationData.dailyRespirationData[displayName][calendarDate]
        : null;
};

export const isDailyRespirationDataFetching = (state) => {
    return state.dailyRespirationData.isFetching;
};

export const isDailyRespirationDataFetchFail = (state) => {
    return state.dailyRespirationData.fetchFailed;
};
